import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_PROCESSING_FEATURE_KEY,
  PaymentProcessingState,
} from './paymentProcessing.slice';

export const getProcessingState = (rootState: any): PaymentProcessingState =>
  rootState[PAYMENT_PROCESSING_FEATURE_KEY];

export const selectProcessingLoading = createSelector(
  getProcessingState,
  (s) => s.isProcessingLoading,
);

export const selectProcessingResultAction = createSelector(
  getProcessingState,
  (s) => s.result?.resultAction,
);

export const selectProcessingResult = createSelector(
  getProcessingState,
  (s) => s.result,
);

export const selectProcessingError = createSelector(
  getProcessingState,
  (s) => s.error,
);

export const selectTransactionId = createSelector(
  getProcessingState,
  (s) => s.result?.transactionId,
);
